import TerminalServiceDetailsContainer from "@features/terminal-services/details/TerminalServiceDetailsContainer";

const TerminalServiceDetailsPage = () => {
  return <TerminalServiceDetailsContainer />;
};

export default TerminalServiceDetailsPage;
